import styled from "styled-components";

export const MobileMenu = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 1000;
`;

export const MobileMenuHeader = styled.div`
  padding: 20px;
  display: flex;
  justify-content: flex-end;
`;

export const MobileMenuContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  gap: 32px;

  a {
    text-decoration: none;
    align-self: flex-start;
  }
`;

export const MobileMenuItem = styled.div`
  color: var(--Black-black, #000);
  text-align: left;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Pretendard;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 42px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 32px;
`;

export const LoginButton = styled.button`
  display: flex;
  padding: 14px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 12px;
  background: var(--Blue-blue-300, #f2f4f7);
  border: none;
  color: #000;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
`;

export const SignupButton = styled(LoginButton)`
  background: #000;
  color: white;
`;

export const CloseMenuButton = styled.button`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
